import texts from './texts.json';

export function formatFloor(value: number) {
  if (value === null || value === undefined) {
    return '';
  }
  if (value === 0) {
    return texts.groundFloor;
  }
  return value.toString();
}
